module.exports = __webpack_public_path__ + "media/images/stars/1-9edec44aba42a9032f16d62ff5098606.gif";